import React from "react";
import { 
  TableRow, 
  TableCell, 
  Box, 
  Typography, 
  Avatar 
} from "@mui/material";
import CustomCheckbox from "./SessionsCustomCheckbox";
import ProjectAvatar from "./SessionsProjectAvatar";
import ActivityBar from "./SessionsActivityBar";

const cellStyle = {
  padding: '10px 16px',
};

const getInitials = (name) => {
  const names = name.split(" ");
  return names.map(n => n[0]).join("").toUpperCase();
};

const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `hsl(${hash % 360}, 60%, 60%)`;
  return color;
};


const SessionsMemberRow = ({ row, isSelected, onSelectToggle, isMeView = false }) => {
  return (
    <TableRow sx={{
      '&:hover': { boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' },
      backgroundColor: '#fff',
      borderRadius: '10px',
      transition: 'box-shadow 0.3s ease',
    }}>
      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        minWidth: '32px', 
        maxWidth: '32px',
        borderRadius: '10px 0 0 10px',
      }}>
        <CustomCheckbox checked={isSelected} onChange={onSelectToggle} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        {row.id}
      </TableCell>  

    <TableCell sx={{
  ...cellStyle,
  border: 'none',
  color: '#626262',
  backgroundColor: '#fff',
  textAlign: 'left'
}}>
  <Box display="flex" alignItems="center" gap={1}>
    <Avatar
      sx={{
        width: '40px',
        height: '40px',
        fontSize: '13px',
        bgcolor: stringToColor(row.projectName),
      }}
    >
      {getInitials(row.projectName)}
    </Avatar>
    <Box>
      <Typography fontWeight="bold">{row.projectName}</Typography>
      <Typography variant="body2" color="text.secondary">
        {row.projectRole}
      </Typography>
    </Box>
  </Box>
</TableCell>

 
      {!isMeView && ( <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'left' }}>
  <Box display="flex" alignItems="center" gap={1}>
    <Avatar src={row.avatar} sx={{ width: '40px', height: '40px', fontSize: '13px' }} />
    <Box>
      <Typography fontWeight="bold">{row.name}</Typography>
      <Typography variant="body2" color="text.secondary">
        {row.role}
      </Typography>
    </Box>
  </Box>
</TableCell> )}



      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.manualHours}
      </TableCell> 

      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.started}  
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.stopped}
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center', color:'#004DFF' }}>
        {row.duration} 
      </TableCell>
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        <ActivityBar activity={row.activity} />
      </TableCell>
      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        textAlign: 'center',
        borderRadius: '0px 10px 10px 0px' 
      }}>
        {row.notes ? (
    <Typography sx={{ cursor: 'pointer', color: '#0076FE', }}>
      {row.notes} Notes
    </Typography>
  ) : (
    <Typography sx={{ color: 'text.secondary' }}>–</Typography>
  )}
      </TableCell>
    </TableRow>
  );
};

export default SessionsMemberRow;
